module.exports = __webpack_public_path__ + "static/Future-of-Work-Template-Articles-1280-x-720-800x450-926b053c72e241d9a6b13984ae986d88.png";